module.exports = __webpack_public_path__ + "static/media/test8_2.7a710930.png";